import { getBookedFdaDisplayName } from "@capone/common";

// Generic Title
export const PORTAL_TITLE = "Capital One Travel Portal";
// Trip Titles
export const MY_TRIPS_TITLE = "My trips and support";
// Disruption Protection Titles
export const DISRUPTION_PROTECTION_TITLE =
  "Flight disruption assistance details";
export const getDisruptionProtectionTitle = (productVariant?: string) =>
  `${getBookedFdaDisplayName(productVariant)} details`;
export const MCP_TITLE = "Rebook a connecting flight";
